(function () {
  'use strict';
  const config = window.harmonyCurrencyConfig;
  if (!config || config.base !== 'INR') return;
  const money = /(?:₹|Rs\.?\s*|INR\s*)([\d,]+(?:\.\d{1,2})?)/g;
  const selector = '.money,.grid-product__price,.product__price,.product__price-savings,.product__unit-price,.ajaxcart__price,.cart__price,.cart__subtotal,[data-product-price],[data-subtotal]';
  const values = new WeakMap();
  let currency = 'INR';
  let rate = null;
  let queued = false;
  let observer;
  const format = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
  function update() {
    queued = false;
    observer.disconnect();
    document.querySelectorAll(selector).forEach(function (element) {
      const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (node.parentElement.closest('script,style,select,textarea,.visually-hidden')) continue;
        const previous = values.get(node);
        const original = previous && node.nodeValue === previous.rendered ? previous.original : node.nodeValue;
        money.lastIndex = 0;
        if (!money.test(original)) continue;
        money.lastIndex = 0;
        const rendered = currency === 'USD' && rate ? original.replace(money, function (_, amount) {
          return format.format(Number(amount.replace(/,/g, '')) * rate) + ' USD';
        }) : original;
        values.set(node, { original: original, rendered: rendered });
        if (node.nodeValue !== rendered) node.nodeValue = rendered;
      }
    });
    document.querySelectorAll('[name="checkout"],a[href="/checkout"]').forEach(function (button) {
      const parent = button.parentElement;
      let notice = parent.querySelector('[data-harmony-currency-notice]');
      if (!notice) {
        notice = document.createElement('p');
        notice.setAttribute('data-harmony-currency-notice', '');
        notice.setAttribute('role', 'status');
        parent.insertBefore(notice, button);
      }
      notice.textContent = currency === 'USD' && rate ? config.notice : currency === 'USD' ? config.unavailable : '';
      notice.hidden = !notice.textContent;
    });
    document.documentElement.dataset.harmonyDisplayCurrency = currency === 'USD' && rate ? 'USD' : 'INR';
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  function schedule() {
    if (!queued) { queued = true; requestAnimationFrame(update); }
  }
  function refreshRate() {
    return new Promise(function (resolve) {
      const script = document.createElement('script');
      const timer = setTimeout(function () { script.remove(); resolve(); }, 8000);
      script.src = 'https://cdn.shopify.com/s/javascripts/currencies.js?v=' + Math.floor(Date.now() / 3600000);
      script.onload = function () {
        clearTimeout(timer);
        const next = window.Currency && window.Currency.rates && window.Currency.rates.INR / window.Currency.rates.USD;
        if (Number.isFinite(next) && next > 0 && next < 1) rate = next;
        script.remove(); schedule(); resolve();
      };
      script.onerror = function () { clearTimeout(timer); script.remove(); schedule(); resolve(); };
      document.head.appendChild(script);
    });
  }
  async function init() {
    observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    const ratesReady = refreshRate();
    let country = '';
    try {
      const response = await fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'browsing_context_suggestions.json?country[enabled]=true', { signal: AbortSignal.timeout(8000) });
      if (response.ok) { const data = await response.json(); country = data.detected_values && data.detected_values.country && data.detected_values.country.handle || ''; }
    } catch (e) {}
    currency = country && country !== 'IN' ? 'USD' : 'INR';
    await ratesReady; schedule();
    setInterval(refreshRate, 3600000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
